import './DraftButtons.scss';
import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { useHistory } from 'react-router';
import { ICurrentWorkspaceStore } from '../../../../modules/workspaces/currentWorkspace/CurrentWorkspace.store';
import { Home } from '../../../routes/config/Home';
import { ProjectStatus } from '../../projects/projects.model';
import { PublishButtonContainer } from '../containers/PublishButton.container';
import { IProjectDetailsStore } from '../projectDetails.store';
import { PublishButton } from './PublishButton';

export const DraftButtons = observer((): ReactElement => {
  const { t } = useTranslator();
  const history = useHistory();
  const projectDetailsStore = useInjection(IProjectDetailsStore.$);
  const currentWorkspaceStore = useInjection(ICurrentWorkspaceStore.$);

  const projectId = projectDetailsStore.id;
  const workspaceId = currentWorkspaceStore.currentWorkspace.id;
  const projectStatus = projectDetailsStore.status;

  const showDraftButtons = projectStatus === ProjectStatus.Draft;

  return showDraftButtons ? (
    <div className='project-draft-right'>
      <PublishButtonContainer>{(childrenProps) => <PublishButton {...childrenProps} />}</PublishButtonContainer>
      <Button
        variant='outlined'
        onClick={() => {
          history.push(Home.Projects.Details.Preview.withParams({ projectId: projectId, workspaceId: workspaceId }));
        }}
      >
        {t('preview')}
      </Button>
    </div>
  ) : (
    <></>
  );
});
